export * from 'store/bolt/trackingV2.js';
import Store from 'store/store';
import * as actions from 'store/actions';

const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	window.firePowsterCustomEvent(action, cat, label);
};

Store.on(actions.TRACK_MODEL_VIEWER_LOAD_START, () => fire('load-started', 'model-viewer', 'true'));
Store.on(actions.TRACK_MODEL_VIEWER_PROGRESS, (progress) => fire('progress', 'model-viewer', progress));
Store.on(actions.TRACK_MODEL_VIEWER_LOADED, () => fire('load-complete', 'model-viewer', 'true'));